<template>
  <!-- <div class="goodList" :style="wrapStyle">
    <router-link
      :to="{ path: '/detail/' + item.id }"
      class="item acea-row row-between-wrapper"
      v-for="(item, index) in goodList"
      :key="index"
      :style="boxStyle"
    >
      <div class="pictrue">
        <img :src="item.image" :style="imageStyle" class="image" />
        <img
          src="@assets/images/one.png"
          class="numPic"
          v-if="isSort === true && index === 0"
        />
        <img
          src="@assets/images/two.png"
          class="numPic"
          v-if="isSort === true && index === 1"
        />
        <img
          src="@assets/images/three.png"
          class="numPic"
          v-if="isSort === true && index === 2"
        />
      </div>
      <div class="underline" :style="bottomBoxStyle">
        <div class="text">
          <div class="line1" :style="textTitleStyle">{{ item.store_name }}</div>
          <div class="money font-color-red" v-if="isPrice">
            <span class="num">{{ item.price }}

            </span>
          </div>
          <div class="vip-money acea-row row-middle" v-if="isShowSale">
            <div
              v-show="false"
              class="vip"
              v-if="item.vip_price && item.vip_price > 0"
            >
              点{{ item.vip_price || 0
              }}<img src="@assets/images/vip.png" class="image" />
            </div>

          </div>
          <div class="movie-box acea-row row-middle row-between author-wrap" v-if="isAuthor">
            <span class="author"><span v-if="item.author">作者:{{item.author}}</span></span>
            <div class="money font-color-red">
              <span class="num">{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isShowShopCart"
        class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"
      ></div>
    </router-link>
  </div> -->
  <div class="goods_lsit">
    <router-link :to="{ path: '/detail/' + item.id }" v-for="(item, index) in goodList" :key="index">

      <div class="items">
        <img :src="item.image">
        <div class="items_size">{{ item.store_name }}</div>
        <div class="book_author" v-if="item.author">{{ item.author }}</div>
        <div class="price">
          <div class="Coupon_money">
            <img src="@/assets/images/icon-money.png" alt="">
            <div>{{ item.price }}</div>
          </div>
          <div class="addCard">+</div>
        </div>

      </div>
    </router-link>
    <div v-if="isShowShopCart" class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  name: "GoodList",
  components: {
    swiper,
    swiperSlide
  },

  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    scrollingProduct: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    },
    isShowSale: {
      type: Boolean,
      default: true
    },
    isPrice: {
      type: Boolean,
      default: true
    },
    isAuthor: {
      type: Boolean,
      default: false
    },
    isShowShopCart: {
      type: Boolean,
      default: true
    },
    boxStyle: {
      type: Object,
      default: () => { }
    },
    wrapStyle: {
      type: Object,
      default: () => { }
    },
    bottomBoxStyle: {
      type: Object,
      default: () => { }
    },
    imageStyle: {
      type: Object,
      default: () => { }
    },
    textTitleStyle: {
      type: Object,
      default: () => { }
    }
  },

};
</script>
<style scoped>
/* .goodList .item {
  border-radius: .2rem;
  margin-left: .22rem;
  box-shadow: 0.06rem 0.06rem 0.1rem 0.02rem #ededed;
  -webkit-box-shadow: 0.06rem 0.06rem 0.1rem 0.02rem #ededed;
  border: none;

}

.goodList .item .pictrue .image {
  width: 2rem;
  margin: 0 auto;
}

.goodList .item .underline {
  border: none;
  width: 100%;
}

.author-wrap>.money {
  margin-top: 0 !important;
}

.author-wrap {
  margin-top: 0.1rem;
}

.author-wrap>.author {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
} */

.goods_lsit {
  display: grid;
grid-template-columns:1fr 1fr;

}

.goods_lsit .items {
  width: 3.333rem;
  background-color: #ffffff;
  margin-left: 0.25rem;
  border-radius: .2rem;
  margin-bottom: 0.2rem;
  box-shadow: 0.06rem 0.06rem 0.1rem 0.02rem #ededed;
  -webkit-box-shadow: 0.06rem 0.06rem 0.1rem 0.02rem #ededed;
  margin-right: 0.1rem;

}

.items img {
  width: 100%;
  height: 3.5rem;
  border-radius: 0.2rem 0.2rem 0rem 0rem;
}

.items_size {
  font-size: 0.25rem;
  height: 0.7rem;
  font-family: PingFangMedium;
  font-weight: 300;
  color: #292929;
  padding-left: 0.1rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.Coupon_money {
  color: #E83627;
  font-size: 0.3rem;
  padding-top: 0.3rem;
  padding-left: 0.1rem;
  font-weight: 600;
  display: flex;
}

.Coupon_money img {
  width: 0.4rem;
  height: 0.4rem;
  margin-top: -0.03rem !important;
}

.price {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.2rem;
}

.addCard {
  margin-top: 0.25rem;
    margin-right: 0.35rem;
    width: 0.35rem;
    height: 0.35rem;
    font-size: 0.5rem;
    text-align: center;
    line-height: 0.35rem;
    border-radius: 49%;
    background-color: red;
    color: #ffffff;
}

.book_author {
  font-size: 0.2rem;
  font-family: PingFangMedium;
  font-weight: 400;
  color: #9F9F9F;
  margin-top: 0.2rem;
  margin-left: 0.1rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

</style>